require('./player-hdcp.jade')
_ = require("lodash")

PlayerHdcpDirective = (HdcpService) ->
  restrict: 'A'
  templateUrl: 'components/form/player-hdcp.jade'
  require: 'ngModel'
  replace: true
  link:(scope, elem, attrs, ctrl) ->
    elem.attr("name", ctrl.$name)

    hdcp_values = HdcpService.getAvailableHdcpList()
    scope.integers = old_integers = hdcp_values.integers
    scope.floats = old_floats = hdcp_values.floats

    scope.updateModel = ->
      if (scope.integer == null or scope.float == null) and scope.integer != scope.float
        ctrl.$setValidity 'hdcp', false
      else
        ctrl.$setValidity 'hdcp', true
        hdcpValue = HdcpService.getHdcpValue scope.integer, scope.float
        ctrl.$setViewValue hdcpValue

    scope.updateInt = (newInt) ->
      scope.integer = newInt
      if newInt == null
        scope.float = null
      else if newInt != null and scope.float == null
        scope.float = '.0'
      scope.updateModel()

    scope.updateFloat = (newFloat) ->
      scope.float = newFloat
      if newFloat == null
        scope.integer = null
      else if newFloat != null and scope.integer == null
        scope.integer = 0
      scope.updateModel()

    ctrl.$render = ->
      hdcpObj = HdcpService.getHdcpObject ctrl.$modelValue
      scope.integer = hdcpObj.integer
      scope.float = hdcpObj.float

    ctrl.$render()

PlayerHdcpDirective.$inject = [
  'HdcpService'
]

module.exports = PlayerHdcpDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/form/player-hdcp-directive.coffee